export default __webpack_public_path__ + "static/media/Maithili_cf_1.c0fdf684.mp3";